function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M53.5 30L33.579 51.629a1 1 0 01-1.472-.002l-12.74-13.872a1 1 0 01.003-1.356l4.392-4.734a1 1 0 011.472.007l6.89 7.556a1 1 0 001.458.021l7.867-8.133m5.503-5.688l-1.764 1.823",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5 12.326A26.868 26.868 0 0036 8.714c-14.912 0-27 12.088-27 27s12.088 27 27 27 27-12.088 27-27c0-5.779-3.063-12.825-4.907-15.525m-4.543-5.016a26.32 26.32 0 011.533 1.407M34.318 1.983a34.447 34.447 0 00-13.593 3.21 34.679 34.679 0 00-13.54 11.265M3.19 23.777a34.422 34.422 0 011.417-3.107M36.764 70.596a34.447 34.447 0 0013.663-2.894 34.679 34.679 0 0013.798-10.949m4.163-7.224a34.42 34.42 0 01-1.49 3.073",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgComplexCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/complex-check.svg";
export { SvgComplexCheck as ReactComponent };